module.exports = __webpack_public_path__ + "img/i-fun.21455c95.svg";